(() => {
  const userAgent = navigator.userAgent;
  const isSafari =
    navigator.vendor === 'Apple Computer, Inc.' &&
    /Safari/.test(userAgent) &&
    !/(CriOS|FxiOS|EdgiOS|OPiOS)/.test(userAgent);

  if (!isSafari) return;

  document.documentElement.classList.add('custom-account-dialog-safari');

  const patchedAccounts = new WeakSet();

  const patchAccount = (account) => {
    if (patchedAccounts.has(account) || !account.shadowRoot) return;

    patchedAccounts.add(account);

    const removeThemeAnimation = () => {
      account.shadowRoot.querySelector('#custom-account-styles')?.remove();
    };

    removeThemeAnimation();

    // Zest injects its dialog animation after the Shopify component upgrades.
    // Keep watching so section reloads cannot restore the Safari-breaking style.
    new MutationObserver(removeThemeAnimation).observe(account.shadowRoot, {
      childList: true,
    });
  };

  const patchAccountsIn = (root) => {
    if (root instanceof Element && root.matches('shopify-account')) {
      patchAccount(root);
    }

    root.querySelectorAll?.('shopify-account').forEach(patchAccount);
  };

  customElements.whenDefined('shopify-account').then(() => {
    patchAccountsIn(document);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(patchAccountsIn);
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
})();
